<qpoint-toolbar [title]="'Upload'"></qpoint-toolbar>

<qpoint-content-container>
  <qpoint-image-cropper (imageChanged)="imageChanged($event)"></qpoint-image-cropper>
</qpoint-content-container>
